import MetaDadosService from '@/services/MetaDadosService'

export const metaDados = {
  namespaced: true,
  actions: {
    GetMeiosDeDistribuicao ({ dispatch },id) {
      return MetaDadosService.GetMeiosDeDistribuicao(id || null)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostMeiosDeDistribuicao ({ dispatch },  payload ) {
      console.log(payload);
      return MetaDadosService.PostMeiosDeDistribuicao(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutMeiosDeDistribuicao ({ dispatch }, payload) {
      console.log(payload)
      let id = payload.id
      delete payload.id
      return MetaDadosService.PutMeiosDeDistribuicao(id, payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeleteMeiosDeDistribuicao ({ dispatch },id) {
      return MetaDadosService.DeleteMeiosDeDistribuicao(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    GetMeiosDeRepresentacao ({ dispatch }, id) {
      return MetaDadosService.GetMeiosDeRepresentacao(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostMeiosDeRepresentacao ({ dispatch }, payload) {
      return MetaDadosService.PostMeiosDeRepresentacao(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutMeiosDeRepresentacao ({ dispatch }, payload) {
      return MetaDadosService.PutMeiosDeRepresentacao(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeleteMeiosDeRepresentacao ({ dispatch },id) {
      return MetaDadosService.DeleteMeiosDeRepresentacao(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    GetOrgaosResponsaveis ({ dispatch }, id) {
      return MetaDadosService.GetOrgaosResponsaveis(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostOrgaosResponsaveis ({ dispatch }, payload) {
      return MetaDadosService.PostOrgaosResponsaveis(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutOrgaosResponsaveis ({ dispatch }, payload) {
      return MetaDadosService.PutOrgaosResponsaveis(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeleteOrgaosResponsaveis ({ dispatch },id) {
      return MetaDadosService.GetOrgaosResponsaveis(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    GetPeriodicidade ({ dispatch },id) {
      return MetaDadosService.GetPeriodicidade(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostPeriodicidade ({ dispatch }, payload) {
      return MetaDadosService.PostPeriodicidade(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutPeriodicidade ({ dispatch }, payload) {
      return MetaDadosService.PutPeriodicidade(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeletePeriodicidade ({ dispatch },id) {
      return MetaDadosService.DeletePeriodicidade(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    GetCargas ({ dispatch },id) {
      return MetaDadosService.GetCargas(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostCargas ({ dispatch }, payload) {
      return MetaDadosService.PostCargas(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutCargas ({ dispatch }, payload) {
      return MetaDadosService.PutCargas(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeleteCargas ({ dispatch },id) {
      return MetaDadosService.DeleteCargas(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    GetDados ({ dispatch },id) {
      return MetaDadosService.GetDados(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PostDados ({ dispatch }, payload) {
      return MetaDadosService.PostDados(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    PutDados ({ dispatch }, payload) {
      return MetaDadosService.PutDados(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    DeleteDados ({ dispatch },id) {
      return MetaDadosService.DeleteDados(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

  },
  state: {},
  mutations: {},
}
